import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0b0e7cff&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0e7cff')) {
      api.createRecord('0b0e7cff', component.options)
    } else {
      api.reload('0b0e7cff', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0b0e7cff&", function () {
      api.rerender('0b0e7cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eB1Y6V0rB0EZ/JS/offershelp.vue"
export default component.exports